module.exports = __webpack_public_path__ + "img/logo1.4109c154.png";